import request from '@/utils/request'

// 查询小微企业名录基本信息列表
export function listNbaseinfo(query) {
  return request({
    url: '/web/xwqy/xwqycx/list',
    method: 'get',
    params: query
  })
}